<template>
  <v-container fluid class="pa-0">
    <v-sheet style="background-color: transparent">
      <v-slide-group v-model="model" show-arrows="desktop">
        <v-slide-item
          class="mb-2 mr-0"
          v-for="(item, index) in dataItems"
          :key="index"
          style="width: 140px"
        >
          <div class="ma-2">
            <v-card
              class="py-2 px-2 card-container"
              outlined
              elevation="1"
              style="height: 220px; border: none; border-radius: 12px"
              @click="openDialog(item)"
            >
              <div class="bg-box">
                <div
                  class="bg-sub-box"
                  :style="{
                    background: setBackgoundBox(),
                  }"
                ></div>
              </div>

              <!-- point -->
              <div
                v-if="item.limit_reached"
                class="d-flex justify-center align-center text-center cover-card-disable"
              >
                <div class="label">{{ $t("limitReached") }}</div>
              </div>
              <!-- date -->
              <div
                v-else-if="item.in_period_remind_date"
                class="d-flex justify-center align-center text-center cover-card-disable"
              >
                <div class="label">{{ $t("textComingSoon") }}</div>
              </div>
              <!-- frequency -->
              <div
                v-else-if="!item.in_period_show_time_selected"
                class="d-flex justify-center align-center text-center cover-card-disable"
              >
                <div class="label">{{ $t("textTimeCannotJoin") }}</div>
              </div>

              <!-- content -->
              <div
                style="
                  width: calc(100% - 16px);
                  height: calc(100% - 16px);
                  position: absolute;
                  z-index: 1;
                "
              >
                <v-img
                  :cover="true"
                  :aspect-ratio="1"
                  width="100%"
                  :lazy-src="require('@/assets/images/image.png')"
                  :src="item.image_url"
                  style="border-radius: 8px; margin-bottom: 2px"
                >
                </v-img>

                <p
                  class="title-mission text-start mb-auto text-subtitle-2 black--text"
                  v-snip="{ lines: 2 }"
                >
                  {{ item.name }}
                </p>

                <div class="bottomleft px-0 d-flex align-center">
                  <div v-if="item.use_reward == false" class="pb-0 pr-1">
                    <div
                      v-if="Array.isArray(item.point) && item.point.length > 0"
                      style="height: 28px; position: relative"
                      :style="{
                        width: `${
                          Array.isArray(item.point) && item.point.length <= 1
                            ? '28px'
                            : Array.isArray(item.point) &&
                              item.point.length <= 2
                            ? '42px'
                            : '56px'
                        }`,
                      }"
                    >
                      <div
                        v-for="(item_point, index_point) in showSymbolPoint(
                          item.point
                        )"
                        :key="index_point"
                        class="d-flex align-center justify-center"
                        style="position: absolute; border-radius: 50%"
                        :style="{
                          left: `${index_point * 14}px`,
                          'z-index': 3 - index_point,
                          border:
                            item.point.length > 1 ? `2px solid #ffffff` : '0px',
                          'border-radius':
                            item.point.length > 1 ? '50%' : '0px',
                          'box-sizing': 'border-box',
                          'background-color':
                            item.point.length > 1
                              ? showSymbolPointBgColor(item_point)
                              : '#ffffff',
                        }"
                      >
                        <PointSymbol
                          :type="item.point[index_point].point_type_type"
                          :symbol="item.point[index_point].point_type_symbol"
                          :color="item.point[index_point].point_type_color"
                          :is_display="true"
                          :outlined_box="false"
                          :size="28"
                        />
                      </div>
                    </div>
                  </div>
                  <v-icon class="pb-0 pr-1" :color="site.color" left v-else
                    >mdi-gift</v-icon
                  >
                  <div
                    class="mb-0 text-start text-subtitle-2 d-flex align-center"
                    :style="{
                      color: site.color,
                      width: `calc(100% - ${
                        Array.isArray(item.point) && item.point.length <= 1
                          ? '36px'
                          : Array.isArray(item.point) && item.point.length <= 2
                          ? '50px'
                          : '64px'
                      })`,
                    }"
                  >
                    <div class="text-truncate" style="width: 100%">
                      {{ showPoint(item) }}
                    </div>
                  </div>
                </div>
              </div>
            </v-card>
          </div>
        </v-slide-item>
      </v-slide-group>
    </v-sheet>

    <!-- dialog detail activity -->
    <DialogDetail
      v-if="dialogDetail"
      :item="item"
      :keyComponent="keyComponent"
      :dialogDetail="dialogDetail"
      :site="site"
      :typeActivity="typeActivity"
      @close="dialogDetail = false"
    />
  </v-container>
</template>

<script>
import moment from "moment";
import DialogDetail from "./activity/dialogDetail.vue";
import { adjustHslBrightness } from "@/config/general-function";
import PointSymbol from "./point/point-symbol.vue";

export default {
  props: ["dataItems", "site", "typeActivity"],
  components: { DialogDetail, PointSymbol },
  data() {
    return {
      model: 0,
      dialogDetail: false,
      item: "",
      keyComponent: 0,
      qrcode_key: "",
    };
  },

  methods: {
    setBackgoundBox() {
      const _color = this.site.color || "#ffffff";
      const lighten = adjustHslBrightness(_color, 50);
      let _style = `linear-gradient(160deg, ${_color}, ${lighten}, #ffffff)`;
      return _style;
    },
    openDialog(item) {
      this.keyComponent++;
      this.dialogDetail = true;
      this.item = item;
    },

    showPoint(pararm) {
      let pointDetail = {
        point: 0,
        point_type_name: "",
      };
      if (Array.isArray(pararm.point) && pararm.point.length > 0) {
        pointDetail = pararm.point[0];
      }
      if (pararm.use_reward == true) {
        return `${this.$t("rewardPrize")}`;
      } else if (pointDetail.point == 0 || pararm.type == "check-in") {
        return `${this.$t("conditionCoin")}`;
      } else if (Array.isArray(pararm.point) && pararm.point.length > 1) {
        // return `${this.$t("textNumberMore", { number: pararm.point.length })}`;
        return `+${pararm.point.length}`;
      } else {
        const formattedPoint = this.$options.filters.commaPoint(
          pointDetail.point
        );
        return `${formattedPoint} ${pointDetail.point_type_name}`;
      }
    },
    showSymbolPoint(points) {
      const firstThree = points.slice(0, 3);
      return firstThree;
    },
    showSymbolPointBgColor(param) {
      let bg = "#ffffff";
      const point_type_color = param.point_type_color;
      const point_type_type = param.point_type_type;
      if (point_type_type != "image") {
        bg = adjustHslBrightness(point_type_color, 60);
      }
      return bg;
    },
  },
  computed: {
    innerHeight() {
      const height = window.innerHeight;
      return height - 100;
    },
  },
  filters: {
    formatDate: function (value) {
      if (!value) return "-";
      return moment(value).format("D MMMM YY");
    },
    commaPoint(value) {
      // comma point number to baht
      if (value == 0) {
        return "0";
      } else if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
  },
};
</script>

<style scoped>
.card-container {
  position: relative;
}
.disabled-card {
  /* background-color: #00000033; */
}

.bottomleft {
  position: absolute;
  bottom: 0px;
  width: 100%;
}
.container1 {
  position: relative;
}
.btn-close {
  position: absolute;
  z-index: 888;
}
.text-over-image {
  background-color: blue;
  color: white;
  font-weight: bold;
  margin-right: 0;
  float: right;
}
.close-button {
  background-color: rgba(0, 0, 0, 0.25);
}
.cover-card-disable {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 2;
  /* background-color: #FFFFFF99; */
  /* background-color: #00000099; */
}
.cover-card-disable .label {
  font-size: 16px;
  font-weight: 500;
  /* color: #FFFFFF; */
  color: #000000;
  border-radius: 16px;
  background-color: #ffffff;
  padding: 0px 8px;
  margin: 0px 0px 72px 0px;
  width: 75%;
  text-align: center;
}

.bg-box {
  position: absolute;
  width: 100%;
  height: 100%;
  margin-left: -8px;
  margin-top: -8px;
  overflow: hidden;
  border-radius: 12px;
}
.bg-sub-box {
  position: relative;
  width: 100%;
  height: 100%;
}
</style>
